import { OracleService, SettingsStore } from '@zen/common-app-parts';
import { useCallback } from 'react';
import { useQuery } from 'react-query';

export function useFetchCommitments(refetchInterval = false) {
  const {
    state: {
      settings: { chain, oracleUrl },
    },
  } = SettingsStore.useStore();
  const fetch = useCallback(() => OracleService.query(oracleUrl, {}), [oracleUrl]);

  return useQuery(['commitments', chain], fetch, {
    refetchInterval,
  });
}

export function useFetchCommitmentsCount(refetchInterval = false, { ticker, start, expiry } = {}) {
  const {
    state: {
      settings: { chain, oracleUrl },
    },
  } = SettingsStore.useStore();
  const fetch = useCallback(() => OracleService.queryCount(oracleUrl, { ticker, start, expiry }), [
    expiry,
    oracleUrl,
    start,
    ticker,
  ]);

  return useQuery(['commitments-count', chain], fetch, {
    refetchInterval,
  });
}
